// lib/zIndex.js — نظام طبقات z-index موحّد (الجولة الختامية 2026-10، البند 4)
// القيم مطابقة حرفياً لسلّم index.css (--z-*) — مصدر واحد للحقيقة بين CSS
// وJS/inline styles. ممنوع أي رقم z-index حرفي جديد خارج هذا الملف أو
// index.css — يفرضه tests/test_zindex_title_lint_guards.py (حارس baseline:
// لا يسمح بأي مخالفة جديدة خارج القائمة المرصودة حالياً).
//
// الترتيب: محتوى < قائمة منسدلة < الرأس العلوي < الشريط السفلي < الدرج/الخلفية
//          < التنبيهات < النوافذ المنبثقة < Toast < التلميحات (الأعلى دائماً).
export const Z_INDEX = {
  base: 1,
  dropdown: 50,
  header: 100,
  bottombar: 200,
  drawer: 300,
  modal: 400,
  notification: 450,
  toast: 500,
  // تصحيح A3 (الجولة الثالثة، 2026-10-12) — كانت 600؛ عناصر أخرى في
  // المنصة (مثل POSPage.jsx) تُركَّب عبر createPortal خاص بها بقيم
  // z-index حرفية قديمة تصل إلى extra_10000 (10000) — فتُغطّي طبقة
  // tooltip (600) كاملةً رغم أن InfoTip يُركَّب عبر Portal المشترك فعلاً.
  // دليل إنتاج حقيقي (جدول ضغطات ⓘ): elementFromPoint في مركز اللوحة لا
  // يطابقها — محجوبة. القيمة الجديدة أعلى من كل أرقام extra_* الحالية
  // (أقصاها 10000) عمداً — التلميحات يجب أن تبقى الأعلى دائماً مهما
  // ارتفعت أرقام أي طبقة أخرى مستقبلاً ضمن هذا السلّم.
  tooltip: 10001,
  // الجولة الأخيرة (البند 4) — نفس القيم الحرفية الأصلية المتفرقة في
  // الملفات، مستخرجة هنا كرمز مسمّى (صفر تغيير سلوكي). راجع index.css.
  extra_neg1: -1,
  extra_0: 0,
  extra_2: 2,
  extra_3: 3,
  extra_5: 5,
  extra_10: 10,
  extra_20: 20,
  extra_40: 40,
  extra_60: 60,
  extra_900: 900,
  extra_999: 999,
  extra_1000: 1000,
  extra_1001: 1001,
  extra_1100: 1100,
  extra_1200: 1200,
  extra_1500: 1500,
  extra_2200: 2200,
  extra_2300: 2300,
  extra_2600: 2600,
  extra_9990: 9990,
  extra_9998: 9998,
  extra_9999: 9999,
  extra_10000: 10000,
};

// zVar("modal") → "var(--z-modal)" — للاستخدام في inline style بدل أرقام حرفية.
// الجولة الأخيرة (البند 4) — يدعم أيضاً مفاتيح extra_N (تُحوَّل إلى extra-N
// لمطابقة اسم متغيّر CSS في index.css، نفس القيمة حرفياً).
export const zVar = (level) => `var(--z-${String(level).replace(/_/g, "-")})`;
